import React, { useCallback, useState } from 'react';

import Select, { SelectOption } from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

type Props = {
  placeholder?: string;
  onChange: (option: SelectOption) => void;
  value: SelectOption | null;
  width?: string;
};

type Response = {
  squads: any[];
};

const SelectSquad = (props: Props) => {
  const [curTimeout, setCurTimeout] = useState<NodeJS.Timeout | null>(null);

  const fetchSquads = useCallback(
    async (name: any) => {
      if (!name) {
        return (async () => [])();
      }

      if (curTimeout) {
        clearTimeout(curTimeout);
      }

      return new Promise(resolve => {
        const newTimeout = setTimeout(async () => {
          try {
            const { squads } = await apiFetch<Response>(null, `corp-api/find/squad?name=${name}`);
            resolve({
              options: squads.map(squad => ({
                label: squad.name,
                value: squad.id,
              })),
            });
          } catch (error) {
            defaultApiFetchErrorHandler(error, { handleHttp: true });
          }
          return [];
        }, 500);
        setCurTimeout(newTimeout);
      });
    },
    [curTimeout],
  );

  return <Select loadOptions={fetchSquads} {...props} />;
};

export default SelectSquad;
